import { Component } from "react";
import Arweave from "arweave";
import { Button, Card } from "react-bootstrap";
import { readContract } from 'smartweave'
import AmaQuestionForm from "./ama_question_form";
import ReactTooltip from "react-tooltip"
import Ama from "./ama.jsx"

const arweave = Arweave.init({
  host: "arweave.net",
  port: 443,
  protocol: "https",
  timeout: 100000,
  logging: false,
});

const amaContractId = 'suEGI_H1NjKhPZVfOJxRTS8sSzaeSMAIZqLfCbSAVj8'

const samAma = {

  "guest": "SamWilliams",
  "archived": true,
  "endOn": 729532,
  "reward": 10,
  "guestAddress": "vLRHFqCw1uHu75xqB4fCDW-QxpkpJxBtFD9g4QYUbfw",
  "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY",
  "description": "Arweave founder & CEO",
  "questions": [
    {
      "QID": "VSiQBgnDwjQDek0JlXpWgKyfNhB8CyipaknmJQpp3lk",
      "question": "Do you think the there's a chance arweave can surpass etherium in value and adoption in the future?",
      "asker": "kks7s-kx6lPdZzl6NSYZQDB76NNFBgmGN5EDZ874fYQ",
      "atBlockheight": 726079,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "BpXfcPkN10o4bqbtDH-cceOL3E7CM0NccYFbNcI-Yxc",
      "question": "what is the plan for engaging more people and letting more people know about arweave?     ",
      "asker": "F3f9v0DHJy0yb8P0o0GD3z1o1-umlItLi3wlD2WoDNc",
      "atBlockheight": 726508,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "uaof1SVLvTclMIxNZ24WF0vGRcSd_sK4-4qqF2dfRVc",
      "question": "hi sam What do you think of the storage computing paradigm？Could ARWEAVE replace Ethereum?",
      "asker": "OVykQflMMLIRD-GvWUOX6rGUw_RNhDD0eXf9quwzJjk",
      "atBlockheight": 726593,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "f8kzcdWXtmnPVfAnRzzkmAC19EcmlwmIc77bXGALXu4",
      "question": "What do you think of Arweve's future mass adoption scenarios",
      "asker": "OVykQflMMLIRD-GvWUOX6rGUw_RNhDD0eXf9quwzJjk",
      "atBlockheight": 726607,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "QID": "xNgx50z_gmU4A7cqIWEx-etqniFw-qkvKNcG2v3Er80",
      "question": "Going forward, do you foresee any major changes being made to the Arweave protocol itself, or is it considered 'done'?",
      "asker": "kaYP9bJtpqON8Kyy3RbqnqdtDBDUsPTQTNUCvZtKiFI",
      "atBlockheight": 727516,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    }
  ],
  "answers": [
    {
      "answerTo": "VSiQBgnDwjQDek0JlXpWgKyfNhB8CyipaknmJQpp3lk",
      "answer": "It's not my place to speculate on prices. In general, though, I think that the value captured by the base layer of the decentralised web could be enormous.",
      "answerTXID": "qgTZtkrcrUY-kue_6lX7ypplyua7d8O15gMti4jkIE8",
      "atBlockheight": 727920,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "BpXfcPkN10o4bqbtDH-cceOL3E7CM0NccYFbNcI-Yxc",
      "answer": "Through building a decentralised marketing infrastructure -- including backing initiatives just like this! Arweave.News now has an incredible full-time team working on producing interesting content around the permaweb ecosystem -- and they are not alone. @OnlyArweave is also starting up a vehicle to focus on getting the word out and pushing Arweave adoption (more on this, soon). On top of that, as we on-board more founders and projects to the ecosystem, they too become heavy transmitters of the 'meme'.",
      "answerTXID": "uTUaQ-3Gkc6FfBmbqmOPA7Uk2ZzOldHcrTaZyNGJLyA",
      "atBlockheight": 727924,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "uaof1SVLvTclMIxNZ24WF0vGRcSd_sK4-4qqF2dfRVc",
      "answer": "It is pretty fascinating! It seems obvious that the key to smart contract scalability is about data availability -- transaction execution is actually an easier and simpler game. @outprog from EverFinance was one of the first to realise this, and wrote it up into an incredible article. It is definitely worth a look.",
      "answerTXID": "GGj41d_wmBD9h6QsFovm-Z3i313GX7FGtmQ3wfLkWF4",
      "atBlockheight": 727925,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "f8kzcdWXtmnPVfAnRzzkmAC19EcmlwmIc77bXGALXu4",
      "answer": "I think the game is to build a new, better web. A good-case outcome for us is to essentially become embedded as the shared knowledge layer of humanity, as well as the core application hosting platform.\n\nIt's early days and it is an exceptionally large goal, but if you had told us 4 years ago where we are today we would not have believed that was possible, either :).",
      "answerTXID": "TuQFYV9ewxgs83rtr9p3-xEd0imBtBZ_QuKpLF7Of9c",
      "atBlockheight": 727930,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
    {
      "answerTo": "xNgx50z_gmU4A7cqIWEx-etqniFw-qkvKNcG2v3Er80",
      "answer": "Interesting question! I think we are on the exponentially decaying curve of changes now. There are still things that we are tweaking, but the broad principles of the Arweave protocol are now locked in place and (mostly) battle-tested. I expect the core protocol changes to continue getting smaller over time.\n\nMuch of the key ecosystem development nowadays is being led by the community in the protocols on top of Arweave core -- work on SmartWeave, bundling, gateways, verified archivers, and much more, are all being spearheaded by the community itself.",
      "answerTXID": "O0qGZvK8wdZHH4LP4eN4gdOpSRvNQmXWajOi3O1Pgqg",
      "atBlockheight": 727932,
      "id": "r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY"
    },
  ]
}

// uBAtZUaLK8rolhSILgfxG_UGU2GcvawhdQjid3K5oE4

class Amas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
    };
  }

  componentDidMount() {
    //window.location.reload()
    this.loadAmas()
   // this.loadContract()
  }

  /*
  loadContract = async (amaId) => {
    const wallet = JSON.parse(sessionStorage.getItem("arweaveWallet"));
    const input = {"function" : "status", "id": amaId}
    const contract = interactRead(arweave, wallet, amaContractId, input)
    .then((contract => contract))
    return contract
  }
  */

  loadAmas = async () => {
    this.setState( { loadingAmas: true } )
    const amasObj = await readContract(arweave, amaContractId)
    this.setState({amas: amasObj["ama"]})
    this.setState( { loadingAmas: false } )
  }

  showQuestionForm = (a) => {
    this.setState({questionToAnswer: a})
    this.setState({showQuestionForm: true})
  }

  showAma = (a) => {
    this.setState({amaToShow: a})
    this.setState({showAma: true})
  }

  goBack = () => {
    window.location.reload()
  }

/*
  getStatus = async (aId) => {
    return await this.loadContract(aId)
  }
*/

  renderAmas = () => {
    const amaList = []
    const amas = this.state.amas
    for (let i in amas) { 
      let a = amas[i]
      amaList.push(
        <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(a)} variant="link">{a.guest}</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[{a.reward} $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>{a.description}</p>
            <Button className="mb-3" onClick={() => this.showQuestionForm(a)} variant="outline-primary">Ask a question</Button>
            <footer className="ama-id"><code className="mt-2">AMA id: {a.id}</code></footer>
          </Card.Body>
      </Card>
      )
    }
    if (Object.keys(amaList).length === 0) { amaList.push(<p>No AMAs at this time</p>) }
    amaList.push(
      <>
      <h2 className="mt-4">Archived AMAs</h2>
      <Card border="dark" className="m-4 mx-auto mb-2">
          <div className="">
            <Card.Header>
              <Button size="lg" onClick={() => this.showAma(samAma)} variant="link">Sam Williams</Button>
              <span className="small" data-html="true" data-tip="ARN (Arweave News Token) is rewarded to users<br/>whose questions are answered by AMA guests,<br/>and to guests for answering questions.">[10 $ARN]</span>
              <ReactTooltip globalEventOff="hover"/>
            </Card.Header>
          </div>
          <Card.Body>
            <p>Arweave CEO & Co-Founder</p>
            <footer className="ama-id"><code className="mt-2">AMA id: r83ZYBWW4g2XoLWHlgq8x3mU7bMBVZT_4cWxu2DGlfY</code></footer>
          </Card.Body>
      </Card>
      </>
    )
    return amaList
  }

  render() {
    const amas = this.renderAmas()
    return (
      <div>
        <div className="mt-4">
          <h2><Button variant="link" className="text-decoration-none" onClick={() => this.goBack()}>[ Back ]</Button> Active AMAs</h2>
          {this.state.loadingAmas ? "Loading..." : null}
          <div className="mb-4">
            {this.state.showAma ? <Ama archived={this.state.amaToShow.archived} ama={this.state.amaToShow} /> : null}
            {!this.state.showQuestionForm && !this.state.showAma ? amas : null }
            {this.state.showQuestionForm ? <AmaQuestionForm question={this.state.questionToAnswer}/> : null }
          </div>
        </div>
      </div>
    );
  }
}

export default Amas;
